/*
	Generated on 12/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React from 'react';
import { Link, useNavigate } from "react-router";
import { useParams } from "@/commons/hooks/useParams"

import { useAuth } from '@/commons/auth';
import { Button, Modal,Spinner } from '@/commons/components';


import deleteKelas from '../services/deleteKelas'


import deleteJadwalKelas from '../services/deleteJadwalKelas'


import deleteKelasDosen from '../services/deleteKelasDosen'

import * as Layouts from "@/commons/layouts";

const JadwalTable = ({ jadwalKelasList,
		 
		 

	}) => {
  const { checkPermission } = useAuth();
  
  
  const [selectedKonfirmasiHapusJadwalKelas, setSelectedKonfirmasiHapusJadwalKelas] = React.useState(null);
  
  
  	const { 	id } = useParams();
  
  const [showModalKonfirmasiHapusKelas, setShowModalKonfirmasiHapusKelas] = React.useState(false);
  
  
  
  	
    const hapus = async (selectedKonfirmasiHapusKelas) => {
      await deleteKelas({
        kelasId: selectedKonfirmasiHapusKelas.kelasId,
      });
  		window.location.reload()
    }
  const [showModalKonfirmasiHapusJadwalKelas, setShowModalKonfirmasiHapusJadwalKelas] = React.useState(false);
  
  
  
  	
    const hapusJadwal = async (selectedKonfirmasiHapusJadwalKelas) => {
      await deleteJadwalKelas({
        id: selectedKonfirmasiHapusJadwalKelas.id,
      });
  		window.location.reload()
    }
  const [showModalKonfirmasiHapusDosenKelas, setShowModalKonfirmasiHapusDosenKelas] = React.useState(false);
  
  
  
  	
    const hapusDosen = async (selectedKonfirmasiHapusDosenKelas) => {
      await deleteKelasDosen({
        id: selectedKonfirmasiHapusDosenKelas.id,
      });
  		window.location.reload()
    }
  
  return (
    <Layouts.ListComponentTableLayout
  	  items={[jadwalKelasList]}
  	  itemsAttrs={[
          {
            id: "ruangan",
            condition: "",
            label: "Ruangan",
  		  featureName: "ruanganName",
            editable: false
          }
  ,
          {
            id: "jadwal",
            condition: "",
            label: "Jadwal",
  		  featureName: "jadwal",
            editable: false
          }
  ]}
        itemsEvents={(jadwalItem) => [
          checkPermission("UpdateJadwalKelas") &&  (
            
            <Link to={`/kelas/${id}/ubah-jadwal?id=${jadwalItem.id}`}>
              <Button
            	id="_WuH9ECwkEfCoct7gkgY0lg"
                size="sm"
                variant=
                    "primary"
              >
                Ubah Jadwal
              </Button>
            </Link>
            
          )
          
  ,
          checkPermission("DeleteJadwalKelas") &&  (
    
    <Link to=''>
      <Button
    	id="_Afq-YC1XEfCiIOe1nt4Q7w"
        size="sm"
        variant=
                    "info"
        onClick={() => {
          setSelectedKonfirmasiHapusJadwalKelas(jadwalItem);
          setShowModalKonfirmasiHapusJadwalKelas(true);
        }}
      >
        Hapus Jadwal
      </Button>
    </Link>
    
  )
  
        ]}
  itemsModals={(jadwalItem) => [
  	<>
  		<Modal
  		isShow={showModalKonfirmasiHapusKelas}
  		title={"Konfirmasi Hapus Kelas"}
  		text={"Are you sure want to proceed?"}
  		>
  		
  		
  		
  		
  		
  				<Link to=''><Button className={`w-full`} variant="tertiary" onClick={() => setShowModalKonfirmasiHapusKelas(false)}>Batal</Button></Link>
  		
  		<Button
  		  id="_37Hf4Jw5Ee-ejYgMQj2CMA"
  		  variant="danger"
  		  onClick={() => hapus(selectedKonfirmasiHapusKelas)}
  		>
  		  Hapus
  		</Button>
  		</Modal>
  		
  		<Modal
  		isShow={showModalKonfirmasiHapusJadwalKelas}
  		title={"Konfirmasi Hapus Jadwal Kelas"}
  		text={"Are you sure want to proceed?"}
  		>
  		
  		
  		
  		
  		
  				<Link to=''><Button className={`w-full`} variant="tertiary" onClick={() => setShowModalKonfirmasiHapusJadwalKelas(false)}>Batal</Button></Link>
  		
  		<Button
  		  id="_v6jJQCwkEfCoct7gkgY0lg"
  		  variant="danger"
  		  onClick={() => hapusJadwal(selectedKonfirmasiHapusJadwalKelas)}
  		>
  		  Hapus
  		</Button>
  		</Modal>
  		
  		<Modal
  		isShow={showModalKonfirmasiHapusDosenKelas}
  		title={"Konfirmasi Hapus Dosen Kelas"}
  		text={"Are you sure want to proceed?"}
  		>
  		
  		
  		
  		
  		
  				<Link to=''><Button className={`w-full`} variant="tertiary" onClick={() => setShowModalKonfirmasiHapusDosenKelas(false)}>Batal</Button></Link>
  		
  		<Button
  		  id="_JkeXIC5REfCiIOe1nt4Q7w"
  		  variant="primary"
  		  onClick={() => hapusDosen(selectedKonfirmasiHapusDosenKelas)}
  		>
  		  Hapus
  		</Button>
  		</Modal>
  		
  </>
  ]}
  />
  )
};

export default JadwalTable;
